import { render, staticRenderFns } from "./ClearComponentFrame.vue?vue&type=template&id=3a8e266b&scoped=true"
import script from "./ClearComponentFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearComponentFrame.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e266b",
  null
  
)

export default component.exports